import styled from 'styled-components';
import Type from "../Type";
export default styled(Type.h1).attrs({
  variant: Type.heading4,
  weight: Type.black
}).withConfig({
  displayName: "HeaderTitle",
  componentId: "xqfva8-0"
})(["padding-bottom:0;"]);